//import service from '@/services/claim-status-api.service';
//import service from '../services/claim-status-api-mock.service';
import service from '../services/claim-status-api.service';

export default {
    namespaced: true,

    state: {
        statuses: [],
        statusReasons: [],
        allReasons: [],
        history: [],
        loading: false
    },

    getters: {
        statusOptions: (state) =>
            state.statuses.map(s => ({
                value: s.id,
                text: s.name
            }))
    },

    mutations: {
        SET_STATUSES(state, data) {
            state.statuses = data;
        },
        SET_STATUS_REASONS(state, data) {
            state.statusReasons = Array.isArray(data) ? data : [];;
        },
        SET_ALL_REASONS(state, data) {
            state.allReasons = Array.isArray(data) ? data : [];;
        },
        SET_HISTORY(state, data) {
            state.history = data;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        }
    },

    actions: {
        async loadLookups({ commit }) {
            console.log('-loadLookups!')
            const [statuses, reasons, allReasons] = await Promise.all([
                service.getStatuses(),
                service.getStatusReasons(),
                service.getAllReasons()
            ]);

            commit('SET_STATUSES', statuses.data);
            commit('SET_STATUS_REASONS', reasons.data);
            commit('SET_ALL_REASONS', allReasons.data);
        },

        //async loadHistory({ commit }, claimId) {
        //    const res = await service.getClaimStatusHistory(claimId);
        //    commit('SET_HISTORY', res.data);
        //},

        async loadHistory({ commit }, claim) {

            if (!claim || !claim.claimId) {
                console.warn('loadHistory called without valid claim:', claim);
                return;
            }

            const res = await service.getClaimStatusHistory(claim.claimId, claim);
            commit('SET_HISTORY', res.data);
        },

        async updateStatus({ commit, dispatch }, payload) {
            commit('SET_LOADING', true);

            try {
                await service.setClaimStatus(payload);

                // reload history after update
                await dispatch('loadHistory', payload.claim);

            } finally {
                commit('SET_LOADING', false);
            }
        }
    }
};
